// ✅ Badge.tsx (Platinum PRO version)

import React from "react";
import clsx from "clsx";

export type BadgeVariant = "default" | "success" | "warning" | "error";

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

const colorMap: Record<BadgeVariant, string> = {
  default:
    "bg-slate-700 text-slate-200",
  success:
    "bg-green-600/20 text-green-400 border border-green-500/30",
  warning:
    "bg-yellow-600/20 text-yellow-400 border border-yellow-500/30",
  error:
    "bg-red-600/20 text-red-400 border border-red-500/30",
};

const Badge: React.FC<BadgeProps> = ({
  children,
  variant = "default",
  className = "",
}) => {
  return (
    <span
      className={clsx(
        "text-xs px-2 py-1 rounded-full font-medium inline-flex items-center justify-center",
        colorMap[variant],
        className
      )}
    >
      {children}
    </span>
  );
};

export default Badge;